export default new (class TextConverter {
  replaceBr(text: string) {
    return text.replace(/\n/g, "<br>");
  }
})();
